import type { AuthAction } from "../reducers/auth";

type AuthApiError = { message?: string; status?: number };

const authActions = {
  START_GETTING_USER: "START_GETTING_USER",
  FINISH_GETTING_USER: "FINISH_GETTING_USER",
  GET_USER_FAIL: "GET_USER_FAIL",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAIL: "LOGIN_FAIL",
  LOGOUT: "LOGOUT",
  SET_UTM_LINK: "SET_UTM_LINK",
  SET_UTM_CHALLENGE: "SET_UTM_CHALLENGE",
  SET_CLEAR_UTM: "SET_CLEAR_UTM",
  IP_NOT_ALLOWED: "IP_NOT_ALLOWED",

  startGettingUser(): AuthAction {
    return { type: "START_GETTING_USER" };
  },

  finishGettingUser(): AuthAction {
    return { type: "FINISH_GETTING_USER" };
  },

  getUserFail(err: AuthApiError): AuthAction {
    return {
      type: "GET_USER_FAIL",
      error: err.message || "Please try again later.",
      showLogin: err?.status === 401,
    };
  },

  login(): AuthAction {
    return { type: "LOGIN_SUCCESS" };
  },

  loginFail(): AuthAction {
    return { type: "LOGIN_FAIL" };
  },

  logout(): AuthAction {
    return { type: "LOGOUT" };
  },

  setUtmLink(utm: string): AuthAction {
    return { type: "SET_UTM_LINK", utm };
  },

  setUtmChallenge(utm: string): AuthAction {
    return { type: "SET_UTM_CHALLENGE", utm };
  },

  setClearUtm(shouldClear: boolean): AuthAction {
    return { type: "SET_CLEAR_UTM", shouldClear };
  },

  ipNotAllowed(err: { message?: string }): AuthAction {
    return { type: "IP_NOT_ALLOWED", error: err.message ?? "" };
  },
};

export default authActions;
